<template>
  <div class="contact-page">
    <section class="contact-hero">
      <h1>Contact Us</h1>
      <p class="contact-hero-sub">Interested in learning more or partnering with us? We’d love to hear from you.</p>
    </section>
    <div class="container">
      <div class="contact-wrap">
      <form
        action="https://formspree.io/f/mjkropon"
        method="POST"
        class="contact-form"
      >
        <label for="contact-name" class="sr-only">Your name</label>
        <input id="contact-name" type="text" name="name" placeholder="Your Name" required />
        <label for="contact-email" class="sr-only">Your email</label>
        <input id="contact-email" type="email" name="email" placeholder="Your Email" required />
        <label for="contact-message" class="sr-only">Your message</label>
        <textarea id="contact-message" name="message" placeholder="Your Message" required></textarea>
        <button type="submit">Send message</button>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  mounted() {
    document.title = 'Contact | Air Surgical';
  }
};
</script>

<style scoped>
.container {
  text-align: center;
  background: #fff;
  padding: 120px 24px 80px;
  min-height: 100vh;
  box-sizing: border-box;
}

.contact-page {
  padding-top: 70px;
}

.contact-hero {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: #fff;
  text-align: center;
  padding: 80px 24px 60px;
}

.contact-hero h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;
}

.contact-hero-sub {
  font-size: 1.0625rem;
  opacity: 0.95;
  margin: 0;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.contact-page .container {
  padding-top: 60px;
}

.contact-wrap {
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  color: #1a1a1a;
  padding: 40px 32px;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}

.contact-form {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.contact-form input,
.contact-form textarea {
  padding: 12px 14px;
  margin: 0 0 16px 0;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-family: inherit;
  box-sizing: border-box;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.contact-form textarea {
  min-height: 140px;
  resize: vertical;
}

.contact-form button {
  padding: 12px 24px;
  background-color: #2563eb;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  margin-top: 8px;
}

.contact-form button:hover {
  background-color: #1d4ed8;
}

.contact-form button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35);
}

@media (max-width: 600px) {
  .container {
    padding: 100px 16px 60px;
  }

  .contact-wrap {
    padding: 28px 20px;
  }
}
</style>
